
import {filter, take} from 'rxjs/operators';
import {
    Component,
    ViewChild,
    ElementRef,
    Renderer2,
    AfterViewInit,
    OnInit,
    OnDestroy,
} from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '../../../interfaces/app-state.interface';
import { ConversationService } from './conversation.service';
import { UserMessageInputComponent } from './user-message-input.component';
import { ConversationAssessorComponent } from '../conversation/conversation-assessor.component';

@AutoUnsubscribe()
@Component({
    selector: 'chat-assessor',
    styleUrls: ['./chat-assessor.component.scss'],
    templateUrl: './chat-assessor.component.html',
})
export class ChatAssessorComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('conversationAssessor', {static: true})
    public conversationAssessor: ConversationAssessorComponent;

    @ViewChild('userMessageInput',  {static: true})
    public userMessageInput: UserMessageInputComponent;

    public subject;
    public historicChat: any[] = [];
    private messagesSubscription: Subscription;
    private assessorMessagemsSubscription: Subscription;
    private NAVIGATE_TIMEOUT = 4000;

    constructor(
        private route: ActivatedRoute,
        private store: Store<AppState>,
        private router: Router,
        private conversationService: ConversationService,
    ) {
        this.getAssessorMessage();
    }

    public ngOnInit() {

        this.subject = this.route.snapshot.queryParams.assunto;
        this.conversationService.startChat(this.subject);

        this.messagesSubscription = this.store
            .select((state) => state.chat.messages).pipe(
            take(1))
            .subscribe((data) => this.historicChat = data);

    }

    public ngAfterViewInit() {
        // ?
    }

    public ngOnDestroy() {
        // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    }

    /**
     * Recebe via event emmiter
     *
     * @param  {} msg
     */
    public getUserMessagens(msg) {
        // Escreve mensagem
        this.conversationAssessor.message = msg;

        // Envia mensagem
        this.conversationService.userMessagens.next(msg);
    }

    /**
     * Recebe mensagens do cliente
     *
     * @param {} msg
     */
    public getUserTypingMessage(msg) {
        // Envia mensagem
        this.conversationService.userTypingMessage.next(msg);
    }

    /**
     * Recebe mensagens do assessor
     */
    public getAssessorMessage() {
        this.assessorMessagemsSubscription = this.conversationService.assessorMessagens$.pipe(
            filter((msg) => msg && msg.message))
            .subscribe((msg) => {
                this.conversationAssessor.message = msg;
            });
    }

    /**
     * Inscrito para saber quando o chat é finalizado
     *
     * @param  {} $event
     */
    public whenChatEnded($event) {
        if ($event) this.userMessageInput.chatReset();
    }

}
